module.exports = __webpack_public_path__ + "img/logo.fe1f9cad.png";